export default __webpack_public_path__ + "static/media/key-control.bc0628c9.svg";